/* global localData, validateEmailInput */
if (document.querySelector('#register-form')) {
  const subscribeContactForm = (() => {
    const r = {
      button: document.querySelector('#register-form a.link'),
      loading: document.querySelector('.loading'),
      contactForm: document.querySelector('#register-form form'),
      sendAjax: () => {
        r.isValid = true;
        const formData = {};
        document.querySelectorAll('#register-form input, textarea').forEach((input) => {
          const type = input.tagName === 'TEXTAREA' ? input.tagName : input.getAttribute('type');
          switch (type) {
            case 'TEXTAREA':
            case 'hidden':
            case 'text':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.parentNode.classList.add('is-failed');
                r.isValid = false;
              } else {
                input.parentNode.classList.remove('is-failed');
              }
              break;
            case 'checkbox':
              formData[input.name] = input.checked;
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.closest('.checkbox').classList.add('is-failed');
                r.isValid = false;
              } else {
                input.closest('.checkbox').classList.remove('is-failed');
              }
              break;
            case 'email':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!validateEmailInput(formData[input.name])) {
                  input.parentNode.classList.add('is-failed');
                  r.isValid = false;
                } else {
                  input.parentNode.classList.remove('is-failed');
                }
              }
              break;
            default:
          }
        });
        if (r.isValid) {
          r.loading.classList.add('is-active');
          const ajax = new XMLHttpRequest();
          const formDataImage = new FormData();
          formDataImage.append('action', 'sendRegisterContactForm');
          formDataImage.append('inputs', JSON.stringify(formData));
          formDataImage.append('id', localData.id);
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            r.loading.classList.remove('is-visible');
            const response = JSON.parse(ajax.responseText);
            r.contactForm.innerHTML = response.data.message;
            r.loading.classList.remove('is-active');
          };
          ajax.send(formDataImage);
        }
      },
      initButton: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.sendAjax();
        });
      },
    };
    return {
      initialize: () => {
        r.initButton();
      },
    };
  })();
  subscribeContactForm.initialize();
}
